import {CodeViewError} from '@github-ui/code-view-shared/components/CodeViewError'
import {useNavigate, useRouteError} from '@github-ui/react-router'
import {useEffect} from 'react'

export class CodeViewPathIsBlobError extends Error {
  constructor() {
    super('Path is a blob')
    this.name = 'CodeViewPathIsBlobError'
  }
}

const ERROR = {
  type: 'badResponseError' as const,
}

export function CodeViewTreeErrorBoundary() {
  const error = useRouteError()
  const navigate = useNavigate()

  useEffect(() => {
    if (error instanceof CodeViewPathIsBlobError) {
      navigate(window.location.pathname.replace('/tree', '/blob'), {replace: true})
    }
  }, [error, navigate])

  // Fallback while redirecting or for non-404 errors
  return error instanceof CodeViewPathIsBlobError ? null : <CodeViewError {...ERROR} />
}
